import { useState, ReactNode } from "react";

interface ButtonProps {
    type?:string;
    className?: string;
    disabled?:boolean;
    isLoading?:boolean;
    children?: ReactNode;
    onClick?: ()=> void;
}

function Button({type, className, disabled, isLoading, children, onClick}:ButtonProps) {  
    const spinner = <i className="fas fa-sync-alt fa-spin"></i>;

    return (
            <button type="button" className={"btn " + className} onClick={onClick} disabled={isLoading || disabled}>{children} {isLoading && spinner}</button>            
    );
}

export default Button;
